import { useState, useEffect } from 'react';
const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        // eslint-disable-next-line consistent-return
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowWidth;
};
export default useWindowWidth;
//# sourceMappingURL=useWindowWidth.js.map